import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)
import Main from "@/components/main/main"
import userMenu from "@/components/menu/menu"

/**
 meta: {
    hide: false, 是否在左侧菜单显示 不显示请设为 true
    title: "列表页面", 菜单标题
    icon: "md-grid", 图标
    roleId: 1 菜单权限id 不填写等同于不需要权限校验
    singlePage: true 单页 非嵌套栏目显示
}
 */

export const agentRoutes = [
  {
    path: "/",
    name: "home",
    component: Main,
    meta: {
      hide: true,
      title: "首页",
      icon: "icon-cangkucangchu-xianxing",
      style: "vertical-align: -1px;",
      singlePage: true,
    },
    redirect: '/homePage',
    children: [],
  },
  {
    path: "/official",
    name: "official",
    meta: {
      hide: true,
      title: "官网",
    },
    redirect: '/register',
    component: () => import("@/views/official/index"),
    children: [
      {
        path: "/register",
        name: "register",
        meta: {
          hide: false,
          title: "登录",
          icon: ''
        },
        component: () => import("@/views/official/home/register")
      },
      {
        path: "/aboutUs",
        name: "aboutUs",
        meta: {
          hide: false,
          title: "关于我们",
          icon: ''
        },
        component: () => import("@/views/official/home/aboutUs")
      },
      {
        path: "/contactUs",
        name: "contactUs",
        meta: {
          hide: false,
          title: "联系我们",
          icon: ''
        },
        component: () => import("@/views/official/home/contactUs")
      },
      {
        path: "/robot",
        name: "robot",
        meta: {
          hide: false,
          title: "RPA机器人",
          icon: ''
        },
        component: () => import("@/views/official/home/rpa")
      },


      {
        path: "/user",
        name: "user",
        meta: {
          hide: false,
          title: "用户中心",
          icon: ''
        },
        component: userMenu,
        children: [
          {
            path: "/homePage",
            name: "homePage",
            meta: {
              hide: false,
              title: "首页",
              icon: ''
            },
            component: () => import("@/views/version2/homePage/homePage")
          },
          {
            path: "/info",
            name: "info",
            meta: {
              hide: false,
              title: "个人资料",
              icon: ''
            },
            component: () => import("@/views/version2/info/basic")
          },
          {
            path: "/certification",
            name: "certification",
            meta: {
              hide: false,
              title: "企业认证",
              icon: ''
            },
            component: () => import("@/views/version2/user/enterprise/certification")
          },
          {
            path: "/member",
            name: "member",
            meta: {
              hide: false,
              title: "成员管理",
              icon: ''
            },
            component: () => import("@/views/version2/user/enterprise/member")
          },
          {
            path: "/balance",
            name: "balance",
            meta: {
              hide: false,
              title: "余额充值",
              icon: ''
            },
            component: () => import("@/views/version2/user/finance/balance")
          },
          {
            path: "/recharge",
            name: "recharge",
            meta: {
              hide: false,
              title: "充值记录",
              icon: ''
            },
            component: () => import("@/views/version2/user/finance/recordList")
          },
          {
            path: "/consumption",
            name: "consumption",
            meta: {
              hide: false,
              title: "消费记录",
              icon: ''
            },
            component: () => import("@/views/version2/user/finance/consumption")
          },
          {
            path: "/invoicing",
            name: "invoicing",
            meta: {
              hide: false,
              title: "开票记录",
              icon: ''
            },
            component: () => import("@/views/version2/user/finance/invoicing")
          },
          {
            path: "/sendList",
            name: "sendList",
            meta: {
              hide: false,
              title: "收发通",
              icon: ''
            },
            component: () => import("@/views/version2/user/send/list")
          },
        ]
      },
    ]
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    meta: {
      hide: true,
      title: "关于我们",
      // singlePage: true // 单页
    },
    component: () => import("@/views/official/aboutUs")
  },
  {
    path: "/contactUs",
    name: "contactUs",
    meta: {
      hide: true,
      title: "联系我们",
      // singlePage: true // 单页
    },
    component: () => import("@/views/official/contactUs")
  },
  {
    path: "/",
    name: "vgm",
    component: Main,
    //productId: "vgm",
    meta: {
      hide: false,
      title: "VGM管理",
      icon: "icon-baoguofahuo-xianxing",
      style: "vertical-align: -1px;",
      singlePage: false,
    },
    children: [
      {
        path: "/vgm/draft",
        name: "vgmDraft",
        productId: "vgm",
        meta: {
          hide: false,
          title: "草稿箱",
          icon: "",
        },
        component: () => import("@/views/new_vgm/draftBox/list"),
      },
      {
        path: "/vgm/details",
        name: "vgmDetails",
        meta: {
          hide: true,
          title: "VGM详情",
          icon: "",
        },
        component: () => import("@/views/new_vgm/draftBox/details"),
      },
      {
        path: "/vgm/send",
        name: "vgmSend",
        productId: "vgm",
        meta: {
          hide: false,
          title: "已发送",
          icon: "",
        },
        component: () => import("@/views/new_vgm/hasBeenSent/list"),
      },
      {
        path: "serviceArea",
        name: "serviceArea",
        meta: {
          hide: false,
          title: "服务范围",
          icon: "",
        },
        component: () => import("@/views/new_vgm/serviceArea/index"),
      },
      // {
      //   path: "/vgm",
      //   name: "vgm",
      //   productId: "1",
      //   meta: {
      //     hide: false,
      //     title: "VGM管理",
      //     icon: "md-heart-outline",
      //   },
      //   component: () => import("@/views/data_vgm/index"),
      // },
    ],
  },
  {
    path: "/cps",
    name: "cps",
    component: Main,
    meta: {
      hide: false,
      title: "舱单管理",
      icon: "icon-dingdan",
      style: "vertical-align: -1px;",
      singlePage: false,
    },
    children: [
      {
        path: "/cps/draft",
        name: "draft",
        productId: "shcps",
        meta: {
          hide: false,
          title: "草稿箱",
          icon: "",
        },
        component: () => import("@/views/new_cps/DraftBox"),
      },
      {
        path: "/cps/waiting",
        name: "waiting",
        productId: "shcps",
        meta: {
          hide: false,
          title: "待发送",
          icon: "",
        },
        component: () => import("@/views/new_cps/UnsendRecord"),
      },
      {
        path: "/cps/send",
        name: "send",
        productId: "shcps",
        meta: {
          hide: false,
          title: "已发送",
          icon: "",
        },
        component: () => import("@/views/new_cps/SendRecord"),
      },
      {
        path: "/cps/update",
        name: "update",
        productId: "shcps",
        meta: {
          hide: false,
          title: "改单记录",
          icon: "",
        },
        component: () => import("@/views/new_cps/UpdateRecord"),
      },
      {
        path: "/cps/delete",
        name: "delete",
        productId: "shcps",
        meta: {
          hide: false,
          title: "删单记录",
          icon: "",
        },
        component: () => import("@/views/new_cps/DeleteRecord"),
      },
      {
        path: "/cps/counterDelete",
        name: "counterDelete",
        productId: "shcps",
        meta: {
          hide: true,
          title: "柜面删单",
          icon: "",
        },
        component: () => import("@/views/new_cps/CounterDelete"),
      },
      {
        path: "/cps/pushSet",
        name: "pushSet",
        productId: "shcps",
        meta: {
          hide: true,
          title: "推送设置",
          icon: "",
        },
        component: () => import("@/views/new_cps/PushSet"),
      },
      {
        path: "/cps/detail",
        name: "cpsDetail",
        productId: "shcps",
        meta: {
          hide: true,
          title: "舱单详情",
          icon: "",
        },
        component: () => import("@/views/new_cps/Detail"),
      },
    ],
  },
  {
    path: "/join",
    name: "join",
    component: Main,
    meta: {
      hide: true,
      title: "加入企业",
      icon: "icon-biaodanku",
      style: "vertical-align: -1px;",
      singlePage: true,
    },
    children: [
      {
        path: "/join",
        name: "join",
        meta: {
          hide: false,
          title: "加入企业",
          icon: "",
        },
        component: () => import("@/views/join/index"),
      },
    ],
  },
  {
    path: "/empty",
    name: "empty",
    component: Main,
    meta: {
      hide: true,
      title: "产品未开通",
      singlePage: false,
    },
    children: [
      {
        path: "/empty",
        name: "empty",
        meta: {
          hide: true,
          title: "产品未开通",
          icon: "",
        },
        component: () => import("@/views/version2/empty")
      }
    ]
  },
  {
    path: "/notFind",
    name: "notFind",
    meta: {
      hide: true,
      title: "页面未找到",
    },
    component: () => import("@/views/page_status/notFind")
  },
  {
    path: "/login",
    name: "login",
    meta: {
      hide: true,
      title: "登录",
      icon: ''
    },
    redirect: '/register',
    component: () => import("@/views/official/home/register")
  },
]

export let constantRoutes = agentRoutes
// 需要权限校验的异步路由
export const asyncRoutes = []
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: agentRoutes
  })

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

// 解决跳转同一个路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}


export default router
